import React from "react";
import Modal from "react-bootstrap/Modal";
import CommunityForm from "../Forms/CommunityForm";

function AddCommunityModal({ show, onHide, community }) {
  const communityName = community
    ? community.communityName
    : "";
  const communityStatus = community ? community.status : "Pending";
  const modalTitle =
    communityStatus === "Pending"
      ? `${communityName} - New Application`
      : `${communityName}`;
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="add-community-modal"
      className="add-community-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="text-uppercase" id="add-community-modal">
          {community ? modalTitle : "Add Community"}
        </Modal.Title>
        {community && (
          <div
            className={`modal-header-status status-${communityStatus.toLowerCase()}`}
          >
            Status:{" "}
            <span className={`span-${communityStatus.toLowerCase()}`}>
              {communityStatus}
            </span>
          </div>
        )}
      </Modal.Header>
      <Modal.Body>
        <CommunityForm formSource="modal" community={community} onHide={onHide} />
      </Modal.Body>
    </Modal>
  );
}

export default AddCommunityModal;
